import styled from "styled-components";
import { theme } from "ui/themes";

interface ComponentBlackThemeProp {
  isBlackTheme?: boolean;
}

export const Container = styled.div`
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
`;

export const Box = styled.section`
  display: flex;
  background-color: ${theme.colors.neutral.white};
  border-radius: 2px;
  margin-bottom: 3rem;
  border: thin solid ${theme.colors.neutral["95"]};
  border-radius: 8px;
`;

export const Title = styled.h2<ComponentBlackThemeProp>`
  font-weight: 500;

  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.neutral.white}`
      : `${theme.colors.blackFriday["115"]}`};

  @media ${theme.device.desktopFirst.tablet} {
    font-size: 1.5rem;
  }
`;

export const Description = styled.div<ComponentBlackThemeProp>`
  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday.white}`
      : `${theme.colors.blackFriday["115"]}`};

  background-color: ${({ isBlackTheme }) =>
    isBlackTheme ? `${theme.colors.blackFriday["175"]}` : ""};

  font-size: 1.4rem;
  padding: 1.8rem 1.6rem;
  font-weight: normal;
  white-space: pre-wrap;
`;
